import DataLayer from "./DataLayer";

export default () => {
    // Include products if partial refund
    DataLayer.track({
        ecommerce: {
            refund: {
                actionField: { id: "Order ID" },
                // products: [
                //     {id: 'P4567', quantity: 1},   // Product ID and quantity. Required for partial refunds.
                //     {id: 'P8901',quantity: 2}
                // ]
            },
        },
    });
};
